import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import {
    UserServiceProxy, ProfileServiceProxy, JobPositionServiceProxy, InstitutionsServiceProxy, CategoryServiceProxy, UserEditDto, CreateOrUpdateUserInput,
    UserRoleDto, PasswordComplexitySetting, UserPhoneDto, UserAddressDto, JobPositionEditDto, InstitutionEditDto, JobPositionListDto,
    InstitutionListDto, NoteEditDto, CategoryDto, CreateOrEditUserCategoryDto, ChangeUserCategoryDto, SituationsServiceProxy, SituationListDto, UserMemberEditDto,
    MemberComplementaryDataEditDto, MemberCategoryEditDto, MemberComplementaryDataItemEditDto, MemberGraduationEditDto,
    UserJobPositionEditDto, RegistrationsServiceProxy, MemberAnnuityServiceProxy, DocumentationEditDto, DocumentEditDto, UpdateDocumentInput, CategoryEditDto, EntityDtoOfInt64, DisaproveDocDto, PaymentChargesServiceProxy, DocumentDto, JobPositionDetailListDto, JobPositionDetailEditDto, EnterpriseServiceProxy, BaseDto, UserEmailDto, MemberWorkplaceDto, EnterpriseListDto
} from '@shared/service-proxies/service-proxies';

import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/AppConsts';
import { CorreiosService } from '@app/shared/common/correios/correios.service';
import { PhonesComponent } from '@app/shared/common/phones/phones.component';
import { AddressesComponent } from '@app/shared/common/addresses/addresses/addresses.component';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { AppNoteEditDtoType, AppSituationType, AppUserAddressDtoType, AppCorrespondenceSituation, PaymentChargeStatus, SubscriptionSituationType, DocumentationStatusMember, ReceivableType, AppPhoneType, StatusIntegracao } from '@shared/AppEnums';
import { CertificateModalComponent } from '@app/event/my-registrations/modal/certificate-modal.component';
import { TicketInfoModalComponent } from "@app/financial/payment/modals/ticket-info-modal.component";
import { PrimengDatatableHelper } from '@shared/helpers/PrimengDatatableHelper';
import { LazyLoadEvent, DataTable, Paginator } from 'primeng/primeng';

import * as _ from 'lodash';
import * as moment from 'moment';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { ReceiptModalComponent } from '@app/financial/receivables/modals/receipt/receipt-modal.component';
import { EmailsComponent } from '@app/shared/common/emails/emails.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
    selector: 'createOrEditUserModal',
    templateUrl: './create-or-edit-user-modal.component.html'
})
export class CreateOrEditUserModalComponent extends AppComponentBase {

    appCorrespondenceSituation = AppCorrespondenceSituation;
    appNoteEditDtoType = AppNoteEditDtoType;
    paymentChargeStatus = PaymentChargeStatus;
    subscriptionSituationType = SubscriptionSituationType;
    documentationStatusMember = DocumentationStatusMember;
    statusIntegracao = StatusIntegracao;

    @ViewChild('userForm') public userForm: NgForm;
    @ViewChild('nameInput') nameInput: ElementRef;
    @ViewChild('createOrEditModal') modal: ModalDirective;
    @ViewChild('emails') emails: EmailsComponent;
    @ViewChild('phones') phones: PhonesComponent;
    @ViewChild('addresses') addresses: AddressesComponent;
    @ViewChild('categoryId') categoryId: number;
    @ViewChild('certificateModal') certificateModal: CertificateModalComponent;
    @ViewChild("ticketInfoModal") ticketInfoModalComponent: TicketInfoModalComponent;
    @ViewChild('dataTablePaymentCharges') dataTablePaymentCharges: DataTable;
    @ViewChild('receiptModal') receiptModalComponent: ReceiptModalComponent;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    primengDatatableHelperAnnuities: PrimengDatatableHelper = new PrimengDatatableHelper();
    primengDatatableHelperCourses: PrimengDatatableHelper = new PrimengDatatableHelper();
    primengDatatableHelperPaymentCharges: PrimengDatatableHelper = new PrimengDatatableHelper();

    emailDto = UserEmailDto;
    phoneDto = UserPhoneDto;
    addressDto = UserAddressDto;

    isUpdateUser = false;
    active = false;
    saving = false;
    loading = false;
    confirmedName: boolean = false;
    originalName: string;
    isTwoFactorEnabled: boolean = this.setting.getBoolean('Abp.Zero.UserManagement.TwoFactorLogin.IsEnabled');
    isLockoutEnabled: boolean = this.setting.getBoolean('Abp.Zero.UserManagement.UserLockOut.IsEnabled');
    passwordComplexitySetting: PasswordComplexitySetting = new PasswordComplexitySetting();

    user: UserEditDto = new UserEditDto();
    roles: UserRoleDto[];

    sendAdmissionEmail = true;
    sendActivationEmail = true;
    setRandomPassword = true;
    receiveActivityNotifications = true;
    passwordComplexityInfo = '';
    profilePicture: string;

    firstCategory = false;
    firstCategoryDto: CategoryEditDto;
    editingCategoryDto: CategoryEditDto;

    canPrintAddressLabel = false;
    firstMember = false;
    changingCategory = false;
    userHasRoleMember = false;
    userHasRoleNotMember = false;
    userMemberSaved: UserMemberEditDto = null;
    userAddressesSaved = [];
    editingCategoriaIndex = null;
    inputCategory: MemberCategoryEditDto = new MemberCategoryEditDto();

    currentStatus: boolean = null;
    currentSituationId = 0;
    currentBaseId = 0;
    observationSituation: string = "";
    observationBase: string = "";
    observationStatus: string = "";

    nationalities: any[];
    categories: CategoryDto[] = [];
    situations: SituationListDto[] = [];
    memberStatusList = [];
    bases: BaseDto[] = [];
    jobPositions: JobPositionListDto[] = [];
    specialities: any[] = [];
    institutions: InstitutionListDto[] = [];
    jobPositionDetails: JobPositionDetailListDto[] = [];
    brazilStates: any[] = CorreiosService.loadBrazilStates();

    enterprises = [];
    registrations = [];
    annuities = [];

    newNote: string = "";
    countName = 0;

    isResident = false;
    certificateActive = false;

    uploadUrl: string = AppConsts.remoteServiceBaseUrl + '/User/UploadDocumentation';

    uploadedFiles: any[] = [];
    uploadedFilesRenamed: any[] = [];
    documentation: DocumentationEditDto = new DocumentationEditDto();
    deletedAnyDocuments = false;
    showMotiveDisapproveDoc = false;
    inputMotiveDisapproveDoc = '';
    savingDoc = false;

    userPendingUpdate = false;
    showComponents = false;

    constructor(
        injector: Injector,
        private _userService: UserServiceProxy,
        private _profileService: ProfileServiceProxy,
        private _appSessionService: AppSessionService,
        private _jobPositionService: JobPositionServiceProxy,
        private _InstitutionService: InstitutionsServiceProxy,
        private _categoryService: CategoryServiceProxy,
        private _situationService: SituationsServiceProxy,
        private _enterpriseService: EnterpriseServiceProxy,
        private _fileDownloadService: FileDownloadService,
        private _registrationsService: RegistrationsServiceProxy,
        private _memberAnnuityService: MemberAnnuityServiceProxy,
        private _paymentChargesService: PaymentChargesServiceProxy
    ) {
        super(injector);
        this.initializeNewUser();
    }

    ngOnInit() {
        this.userPendingUpdate = this._appSessionService.getUserPendingUpdate();
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');

        $('.datetimepicker').datetimepicker({
            locale: abp.localization.currentLanguage.name,
            format: 'L'
        });

        $('.tab-drop .nav-tabs').tabdrop({ text: this.l("more options"), align: 'right' });
        $('#m-portlet-category').mPortlet();
    }

    show(userId?: number): void {

        this.initializeNewUser();
        this.active = true;

        this._userService.getUserForEdit(userId).subscribe(userResult => {

            if (!!userResult.user.id) {
                this.user = userResult.user;
                this.originalName = this.user.name;
                this.documentation = userResult.documentation;
            }

            this.roles = userResult.roles;

            this.getProfilePicture(userResult.profilePictureId);

            this.nationalities = CorreiosService.loadNationalities();
            this._categoryService.getForSelect("", undefined, true, true).subscribe(result => {
                this.categories = result.items;
            });

            // Get Member Types
            this._situationService.getSituationsForSelect("", AppSituationType.Member).subscribe(result => {
                this.situations = result.items;
            });

            //Get Member Status
            this._userService.getMemberStatusForSelect(undefined)
                .subscribe(result => {
                    this.memberStatusList = result.items;
                });

            this._userService.getBasesForSelect("").subscribe(result => {
                this.bases = result.items;
            });

            if (userId) {
                this.isUpdateUser = true;

                setTimeout(() => {
                    this.setRandomPassword = false;
                }, 0);

                this.currentStatus = this.user.isActive;
                this.currentSituationId = this.user.situationId;
                this.currentBaseId = this.user.member ? this.user.member.baseId : 0;
                this.sendActivationEmail = false;
                this.receiveActivityNotifications = this.user.receiveActivityNotifications;

                this.userMemberSaved = this.user.member;
                this.userAddressesSaved = this.user.addresses;

                this.getAnnuitiesGenerated();
                this.getRegistrations();
            }

            if (this.user.phones.length == 0) {

                let phone = new UserPhoneDto();
                phone.type = AppPhoneType.Mobile;
                phone.ddi = '55';
                this.user.phones.push(phone);
            }

            if (!this.user.jobPositions)
                this.user.jobPositions = [];

            if (this.user.member && this.user.member.graduation) {
                if (!this.user.member.graduation.workplaces)
                    this.user.member.graduation.workplaces = []
            }

            this._profileService.getPasswordComplexitySetting().subscribe(passwordComplexityResult => {
                this.passwordComplexitySetting = passwordComplexityResult.setting;
                this.setPasswordComplexityInfo();
            });

            this.checkRolesActived();
            this.verifyIsResisdent();

            this.modal.show();

            setTimeout(() => {
                this.getReceivables();
            }, 0);
        });
    }

    setPasswordComplexityInfo(): void {

        this.passwordComplexityInfo = '<ul>';

        if (this.passwordComplexitySetting.requireDigit) {
            this.passwordComplexityInfo += '<li>' + this.l('PasswordComplexity_RequireDigit_Hint') + '</li>';
        }

        if (this.passwordComplexitySetting.requireLowercase) {
            this.passwordComplexityInfo += '<li>' + this.l('PasswordComplexity_RequireLowercase_Hint') + '</li>';
        }

        if (this.passwordComplexitySetting.requireUppercase) {
            this.passwordComplexityInfo += '<li>' + this.l('PasswordComplexity_RequireUppercase_Hint') + '</li>';
        }

        if (this.passwordComplexitySetting.requireNonAlphanumeric) {
            this.passwordComplexityInfo += '<li>' + this.l('PasswordComplexity_RequireNonAlphanumeric_Hint') + '</li>';
        }

        if (this.passwordComplexitySetting.requiredLength) {
            this.passwordComplexityInfo += '<li>' + this.l('PasswordComplexity_RequiredLength_Hint', this.passwordComplexitySetting.requiredLength) + '</li>';
        }

        this.passwordComplexityInfo += '</ul>';
    }

    getProfilePicture(profilePictureId: string): void {
        if (!profilePictureId) {
            this.profilePicture = '/assets/common/images/default-profile-picture.png';
        } else {
            this._profileService.getProfilePictureById(profilePictureId).subscribe(result => {

                if (result && result.profilePicture) {
                    this.profilePicture = 'data:image/jpeg;base64,' + result.profilePicture;
                } else {
                    this.profilePicture = '/assets/common/images/default-profile-picture.png';
                }
            });
        }
    }

    initializeNewUser(): void {

        this.countName = 0;

        this.isUpdateUser = false;
        this.newNote = undefined;

        this.sendAdmissionEmail = true;
        this.setRandomPassword = true;
        this.sendActivationEmail = true;
        this.receiveActivityNotifications = true;
        this.canPrintAddressLabel = false;
        this.firstCategory = true;
        this.firstMember = true;
        this.observationSituation = "";
        this.observationBase = "";
        this.observationStatus = "";
        this.userMemberSaved = null;
        this.userAddressesSaved = [];
        this.registrations = [];
        this.uploadedFiles = [];
        this.uploadedFilesRenamed = [];
        this.deletedAnyDocuments = false;
        this.showMotiveDisapproveDoc = false;

        this.documentation = new DocumentationEditDto();

        this.user = new UserEditDto();
        this.user.isActive = true;
        this.user.notes = [];
        this.user.emails = [];
        this.user.phones = [];
        this.user.addresses = [];
        this.user.member = new UserMemberEditDto();
        this.user.member.graduation = new MemberGraduationEditDto();
        this.user.member.nationalityName = "BRASILEIRO";
        this.user.member.correspondenceSituation = AppCorrespondenceSituation.Correspondence;
        this.user.jobPositions = [];

        this.user.member.categories = [];
        this.user.member.categories.push(new MemberCategoryEditDto());

        this.destroyChangeCategory();
        this.closeDisapproveDoc();
    }

    onShown(): void {
        $("[name='nameInput']").focus();
    }

    onHidden(): void {
        this.close();
    }

    addErrorTabEmails(): string {
        return this.formEmailsIsInvalid() && this.emails.emailsForm.touched ? "has-error-tab" : "";
    }

    addErrorTabPhones(): string {
        return this.formPhonesIsInvalid() && this.phones.phonesForm.touched ? "has-error-tab" : "";
    }

    addErrorTabAddresses(): string {
        return this.formAddressesIsInvalid() && this.addresses.addressesForm.touched ? "has-error-tab" : "";
    }

    formEmailsIsInvalid(): boolean {
        return this.emails && this.emails.emailsForm.invalid;
    }

    formPhonesIsInvalid(): boolean {
        return this.phones && this.phones.phonesForm.invalid;
    }

    formAddressesIsInvalid(): boolean {
        return this.addresses && this.addresses.addressesForm.invalid;
    }

    formDocumentIsInvalid(): boolean {
        return !!this.uploadedFiles && !!this.documentation && !!this.documentation.documents && this.uploadedFiles.length + this.documentation.documents.length > 10;
    }

    formIsValid(formValid: boolean): boolean {

        return formValid && !this.formEmailsIsInvalid() && !this.formPhonesIsInvalid() && !this.formAddressesIsInvalid() && !this.formDocumentIsInvalid()
    }

    save(): void {

        this.addNote();

        let input = new CreateOrUpdateUserInput();
        input.user = this.user;
        input.setRandomPassword = this.setRandomPassword;
        input.sendActivationEmail = this.sendActivationEmail;
        input.assignedRoleNames =
            _.map(
                _.filter(this.roles, { isAssigned: true }), role => role.roleName
            );

        input.sendAdmissionEmail = (this.userHasRoleMember && !this.user.id) ? this.sendAdmissionEmail : false;
        input.user.receiveActivityNotifications = this.receiveActivityNotifications;

        if (!!this.observationSituation) {

            let note = new NoteEditDto();
            note.description = this.observationSituation;
            note.type = AppNoteEditDtoType.Situation;
            note.creationTime = moment();

            input.user.notes.push(note);
        }

        if (!!this.observationBase) {

            let note = new NoteEditDto();
            note.description = this.observationBase;
            note.type = AppNoteEditDtoType.General;
            note.creationTime = moment();

            input.user.notes.push(note);
        }

        if (!!this.observationStatus) {

            let note = new NoteEditDto();
            note.description = this.observationStatus;
            note.type = AppNoteEditDtoType.Activate;
            note.creationTime = moment();

            input.user.notes.push(note);
        }

        if (input.user.situation) {
            this.user.situation = undefined;
        }

        input.user.emails.forEach(email => {
            email.id = undefined;
        });

        input.user.phones.forEach(phone => {
            phone.id = undefined;
        });

        input.user.addresses.forEach(address => {
            address.id = undefined;
        });

        if (input.user.member) {

            if (this.firstCategory) {
                input.user.member.categories[0].beginDate = moment();

                if (this.firstCategoryDto.levels.length == 0) {
                    input.user.member.categories[0].categoryLevelId = undefined
                }
            }

            if (input.user.member.complementaryData) {
                input.user.member.complementaryData.items.forEach(item => {
                    item.id = undefined;
                });
            }

            if (input.user.member.graduation && input.user.member.graduation.workplaces) {

                input.user.member.graduation.workplaces.forEach(workplace => {
                    workplace.id = undefined;
                });
            }
        }

        input.user.jobPositions.forEach(jobPosition => {
            jobPosition.id = undefined;
        });

        if (this.uploadedFilesRenamed.length > 0) {
            input.documentation = new DocumentationEditDto();
            input.documentation.documents = [];
            input.documentation.status = DocumentationStatusMember.WaitingForApproval;

            this.uploadedFilesRenamed.forEach(x => {

                let doc = new DocumentEditDto();
                doc.input = new UpdateDocumentInput();
                doc.input.fileName = x.fileName;

                input.documentation.documents.push(doc);
            });
        }

        if (this.documentation && this.documentation.documents && this.documentation.documents.length > 0) {

            if (!input.documentation) {
                input.documentation = new DocumentationEditDto();
                input.documentation.documents = [];
                input.documentation.status = this.documentation.status;
            }

            this.documentation.documents.forEach(x => {

                let doc = new DocumentEditDto();
                doc.documentId = x.documentId;
                doc.fileExtension = x.fileExtension;
                doc.fileName = x.fileName;
                input.documentation.documents.push(doc);
            });

            input.documentation.status = this.deletedAnyDocuments || this.uploadedFilesRenamed.length ? DocumentationStatusMember.WaitingForApproval : this.documentation.status;

            if (input.documentation.status == this.documentationStatusMember.Disapproved) {
                input.documentation.note = this.documentation.note;
            }
        }

        this.saving = true;
        this._userService.createOrUpdateUser(input)
            .finally(() => { this.saving = false; })
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);

                if (this.userPendingUpdate && this.user.id == this._appSessionService.userId) {
                    window.location.reload();
                }
            });
    }

    close(): void {
        this.active = false;
        this.situations = [];
        this.memberStatusList = [];
        this.bases = [];
        this.categories = [];

        this.desableUpdateCategory()
        this.modal.hide();
    }

    /// Roles
    getAssignedRoleCount(): number {
        return _.filter(this.roles, { isAssigned: true }).length;
    }

    checkRolesActived(): void {

        this.showComponents = false;

        let rolesMember = _.filter(this.roles, { isAssigned: true, isMember: true });
        let rolesSelected = _.filter(this.roles, r => r.isAssigned == true && r.roleName != 'ScientificWorkCoAuthor');

        if (rolesMember.length > 0) {
            this.userHasRoleMember = true;
            this.adjustLayoutWithMember();
        }
        else {
            this.userHasRoleMember = false;
            this.adjustLayoutWithoutMember();
        }

        if (rolesSelected.length - rolesMember.length > 0)
            this.userHasRoleNotMember = true;
        else
            this.userHasRoleNotMember = false;

        setTimeout(() => {
            this.showComponents = true;
            $('.tab-drop .nav-tabs').tabdrop({ text: this.l("more options"), align: 'right' });
        }, 100);
    }

    adjustLayoutWithMember(): void {

        if (!this.user.member)
            this.user.member = this.userMemberSaved;

        if (!this.user.member)
            this.user.member = new UserMemberEditDto();

        this.user.member.nationalityName = "BRASILEIRO";

        if (this.user.member.correspondenceSituation == undefined)
            this.user.member.correspondenceSituation = AppCorrespondenceSituation.Correspondence;

        if (!this.user.member.categories || this.user.member.categories.length == 0) {
            this.user.member.categories = [];
            this.user.member.categories.push(new MemberCategoryEditDto());
        }
        else if (this.user.member.categories.length > 0 && this.user.member.categories[0].id) {
            this.firstCategory = false;
        }

        if (!this.user.member.complementaryData) {
            this.user.member.complementaryData = new MemberComplementaryDataEditDto();
            this.user.member.complementaryData.items = [];
        }

        if (!this.user.member.graduation)
            this.user.member.graduation = new MemberGraduationEditDto();

        if (!this.user.jobPositions)
            this.user.jobPositions = [];

        if (this.user.phones.length == 0) {

            let phone = new UserPhoneDto();
            phone.type = AppPhoneType.Mobile;
            phone.ddi = '55';
            this.user.phones.push(phone);
        }

        if (this.user.addresses.length == 0)
            this.user.addresses = this.userAddressesSaved;

        if (this.user.addresses.length == 0) {

            let address = new UserAddressDto();
            address.countryName = 'BRASIL';
            address.type = AppUserAddressDtoType.Home;
            address.isMailing = true;

            this.user.addresses.push(address);
        }

        if (this.user.addresses.length > 0 && this.user.addresses[0].id)
            this.canPrintAddressLabel = true;
    }

    adjustLayoutWithoutMember(): void {

        this.user.member = null;
        this.user.addresses = [];
    }

    /// Account User
    needObservationStatus(): boolean {
        return this.user.isActive != this.currentStatus && !!this.user.id;
    }

    /// Address Label
    getUserAddressTag(): void {

        let userIds = [];
        userIds.push(this.user.id);

        this._userService.getUserAddressTags(
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            userIds,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        )
            .subscribe(result => {
                this._fileDownloadService.downloadTempFile(result);
            });
    }


    /// Personal Informations
    upadateDateBornDate(value: string) {

        if (value) {
            this.user.member.bornDate = moment(value, 'L');
        }
        else {
            this.user.member.bornDate = moment();
            $('[name=bornDateUser]').val(moment().format('DD/MM/YYYY'));
        }
    }

    checkCrmUf(): void {
        if (!!!this.user.member.crm)
            this.user.member.crmUf = '';
    }

    needObservation(): boolean {
        return this.user.situationId != this.currentSituationId && !!this.user.id;
    }

    needObservationBase(): boolean {
        return this.user.member.baseId != this.currentBaseId && !!this.user.member.baseId;
    }

    needSpecialityBase(): boolean {
        let selectedBase = this.bases.length ? this.bases.filter(x => x.id == this.user.member.baseId)[0] : null;
        return selectedBase && selectedBase.requireSpeciality;
    }

    /// Category
    verifyIsResisdent(): void {

        this.isResident = false;

        if (this.user && this.user.member && this.user.member.categories.length > 0) {
            if (this.firstCategory) {

                let _category = _.filter(this.categories, { id: +this.user.member.categories[0].categoryId });
                if (_category.length > 0 && _category[0].isResident) {
                    this.isResident = true;
                }

                this.firstCategoryDto = _category[0];
            }
            else {

                let categories = _.filter(this.user.member.categories, { endDate: undefined });
                if (categories.length > 0 && categories[0].category.isResident) {
                    this.isResident = true;
                }
            }
        }
    }

    changeCategory(): void {
        this.desableUpdateCategory();
        this.changingCategory = true;
    }

    destroyChangeCategory(): void {
        this.changingCategory = false;
    }

    saveNewCategory(): void {

        let msg = this.l('If you change the category and the member has a paid annuity, will be created a new Payable to the old category and a new Receivable to the new category.');
        msg += ' ' + this.l('This operation not change categories in registrations.');

        this.message.confirm(
            msg,
            (isConfirmed) => {
                if (isConfirmed) {

                    let input = new ChangeUserCategoryDto();

                    input.categoryId = this.inputCategory.categoryId;

                    if (this.editingCategoryDto.levels.length > 0) {
                        input.categoryLevelId = this.inputCategory.categoryLevelId;
                    }

                    input.note = this.inputCategory.note;
                    input.userId = this.user.id;
                    input.endDate = moment();

                    this._userService.changeUserCategory(input)
                        .subscribe(() => {

                            this.destroyChangeCategory();
                            this.getUserCategories(input.userId);
                            this.getAnnuitiesGenerated();
                            this.documentation = new DocumentationEditDto();
                        });
                }
            }
        );
    }

    getUserCategories(userId: number): void {

        this._userService.getUserCategories(userId)
            .subscribe(result => {

                this.editingCategoriaIndex = null;
                this.inputCategory = new MemberCategoryEditDto();

                this.verifyIsResisdent();
                this.user.member.isForeign = this.isForeign();
                this.user.member.categories = result.items;
            });
    }

    upadateDateCategory(isBeginDate: boolean, value: string) {

        if (isBeginDate)
            this.inputCategory.beginDate = value ? moment(value, 'L') : moment();
        else
            this.inputCategory.endDate = value ? moment(value, 'L') : undefined;
    }

    isEditingThisCategoria(index: number): boolean {

        return this.editingCategoriaIndex == index;
    }

    enableUpdateCategory(index: number): void {

        this.editingCategoriaIndex = index;
        this.changingCategory = false;
        let category = this.user.member.categories[index];

        this.setEditingCategoryDto(category.categoryId);

        this.inputCategory = new MemberCategoryEditDto();
        this.inputCategory.id = category.id;
        this.inputCategory.categoryId = category.categoryId;
        this.inputCategory.categoryLevelId = category.categoryLevelId;
        this.inputCategory.beginDate = category.beginDate;
        this.inputCategory.endDate = category.endDate;
        this.inputCategory.note = category.note;
        this.inputCategory.userId = category.userId;
    }

    desableUpdateCategory(): void {

        this.editingCategoriaIndex = null;
        this.inputCategory = new MemberCategoryEditDto();
    }

    updateCategory(): void {

        let msg = this.l('This operation not change categories in registrations.');

        this.message.confirm(
            msg,
            (isConfirmed) => {
                if (isConfirmed) {

                    let input = new CreateOrEditUserCategoryDto();
                    input.id = this.inputCategory.id;
                    input.categoryId = this.inputCategory.categoryId;

                    if (this.editingCategoryDto.levels.length > 0) {
                        input.categoryLevelId = this.inputCategory.categoryLevelId;
                    }

                    input.beginDate = this.inputCategory.beginDate;
                    input.endDate = this.inputCategory.endDate;
                    input.note = this.inputCategory.note;
                    input.userId = this.user.id;

                    this._userService.updateUserCategory(input)
                        .subscribe(() => {

                            this.getUserCategories(input.userId);
                        });
                }
            }
        );
    }

    setEditingCategoryDto(categoryId: number, index?: number): void {

        this.editingCategoryDto = undefined;
        this.inputCategory.categoryLevelId = undefined;

        if (index) {
            this.user.member.categories[index].categoryLevelId = undefined;
        }

        let categories = _.filter(this.categories, { id: +categoryId });

        if (categories.length > 0) {

            setTimeout(() => {
                this.editingCategoryDto = categories[0];
            }, 0);
        }
    }

    deleteCategory(index: number): void {

        let category = this.user.member.categories[index];
        let msg = this.l('Category') + ' ' + category.category.name + ' ' + this.l('will be deleted.');

        this.message.confirm(
            msg,
            (isConfirmed) => {
                if (isConfirmed) {
                    this._userService.deleteUserCategory(this.user.id, category.id)
                        .subscribe(() => {
                            this.getUserCategories(this.user.id);
                        });
                }
            }
        );
    }

    isForeign(): boolean {

        return this.user.situationId == 4;//4=Estrangeiro
    }



    /// Complementary Data
    upadateDateAdminSaesp(value: string) {
        this.user.member.complementaryData.adminSaesp = value ? moment(value, 'L') : null;
    }

    upadateDateAdminAtv(value: string) {
        this.user.member.complementaryData.adminAtv = value ? moment(value, 'L') : null;
    }

    upadateExamDate(index: number, value: string) {

        if (value) {
            this.user.member.complementaryData.items[index].examDate = moment(value, 'L');
        }
        else {
            this.user.member.complementaryData.items[index].examDate = moment();
            $('[name=examDate' + index + ']').val(moment().format('DD/MM/YYYY'));
        }
    }

    addItemComplementaryData(): void {

        let item = new MemberComplementaryDataItemEditDto();
        item.examDate = moment();
        item.id = this.countName--;

        this.user.member.complementaryData.items.push(item);
    };

    deleteItemComplementaryData(index: number): void {
        this.user.member.complementaryData.items.splice(index, 1);
    }


    /// Job Position
    deleteJobPosition(index: number): void {
        this.user.jobPositions.splice(index, 1);
    };

    addJobPosition(): void {

        let jobPosition = new UserJobPositionEditDto();
        jobPosition.jobPosition = null;
        jobPosition.institution = null;
        jobPosition.jobPositionDetail = null;
        jobPosition.id = this.countName--;

        this.user.jobPositions.push(jobPosition);
    };

    addWorkplace(): void {

        let workplace = new MemberWorkplaceDto();
        workplace.enterprise = null;
        workplace.id = this.countName--;


        this.user.member.graduation.workplaces.push(workplace);
    };

    deleteWorkplace(index: number): void {

        this.user.member.graduation.workplaces.splice(index, 1);
    };

    checkNewWorkplace(index: number) {

        let value: any = this.user.member.graduation.workplaces[index].enterprise;

        if (value != "" && typeof value === "string") {
            let _enterprise = new EnterpriseListDto();
            _enterprise.companyName = value;

            this.user.member.graduation.workplaces[index].enterprise = _enterprise;
        }
    }

    upadateDate(index: number, isBeginDate: boolean, value: string) {

        if (isBeginDate)
            this.user.jobPositions[index].beginDate = value ? moment(value, 'L') : null;
        else
            this.user.jobPositions[index].endDate = value ? moment(value, 'L') : null;
    }

    // Get Job Positions
    filterJobPositions(event): void {
        this._jobPositionService.getJobPositionsForSelect(event.query, null, 10, 0).subscribe(result => {
            this.jobPositions = result.items;
        });
    }

    filterSpecialities(event): void {

        this._userService.getAllSpecialitiesForSelect(event.query).subscribe(result => {
            this.specialities = result;
        });
    }

    // Get Institutions
    filterInstitutions(event): void {
        this._InstitutionService.getInstitutionsForSelect(event.query, null, 10, 0).subscribe(result => {
            this.institutions = result.items;
        });
    }

    // Get Job Positions
    filterJobPositionDetails(event): void {
        this._jobPositionService.getJobPositionDetailsForSelect(event.query, null, 10, 0).subscribe(result => {
            this.jobPositionDetails = result.items;
        });
    }

    checkNewJobPosition(index: number) {

        let value: any = this.user.jobPositions[index].jobPosition;

        if (value != "" && typeof value === "string") {
            let _jobPosition = new JobPositionEditDto();
            _jobPosition.name = value;

            this.user.jobPositions[index].jobPosition = _jobPosition;
        }
    }


    checkNewJobPositionDetail(index: number) {

        let value: any = this.user.jobPositions[index].jobPositionDetail;

        if (value != "" && typeof value === "string") {
            let _jobPositionDetail = new JobPositionDetailEditDto();
            _jobPositionDetail.description = value;

            this.user.jobPositions[index].jobPositionDetail = _jobPositionDetail;
        }
    }

    checkNewInstitution(index: number) {

        let value: any = this.user.jobPositions[index].institution;

        if (value != "" && typeof value === "string") {
            let _institution = new InstitutionEditDto();
            _institution.name = value;

            this.user.jobPositions[index].institution = _institution;
        }
    }

    checkNewSpeciality(index: number) {
        let value: any = this.specialities[index];

        if (value != "" && typeof value === "string") {
            let _speciality = value;

            this.specialities[index] = _speciality;
        }
    }


    /// Insert on View University Graduation
    addGraduation(): void {
        this.user.member.graduation = new MemberGraduationEditDto();
    }

    // Get Enterprises
    filterEnterprises(event): void {
        this._enterpriseService.getEnterpriseForSelectAsync(
            event.query,
            undefined,
            undefined,
        ).subscribe(result => {
            this.enterprises = result.items;
        });
    }

    // Annuities
    getAnnuitiesGenerated() {

        this._memberAnnuityService.getUserMemberAnnuities(
            this.user.id,
            undefined,
            undefined
        )
            .finally(() => {
                this.primengDatatableHelperAnnuities.hideLoadingIndicator();
            })
            .subscribe(result => {
                this.annuities = result.items;
                this.primengDatatableHelperAnnuities.totalRecordsCount = result.items.length;
                this.primengDatatableHelperAnnuities.records = result.items;
            });
    }

    // Courses
    getRegistrations(): void {
        this._registrationsService.getUserRegistrations(
            this.user.id,
            undefined,
            undefined,
            undefined,
            undefined
        )
            .subscribe(result => {
                this.registrations = result.items;
                this.primengDatatableHelperCourses.totalRecordsCount = result.items.length;
                this.primengDatatableHelperCourses.records = result.items;
            });
    }


    //Notes
    addNote(): void {

        if (this.newNote) {

            let note = new NoteEditDto();
            note.description = this.newNote;
            note.type = AppNoteEditDtoType.General;
            note.creationTime = moment();

            this.newNote = "";
            this.user.notes.push(note);
        }
    }

    // Documents
    onUpload(event): void {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }

        if (event.xhr) {
            this.readFiles(event.xhr.response)
        }

        this.closeDisapproveDoc();
    }

    onBeforeSend(event): void {
        event.xhr.setRequestHeader('Authorization', 'Bearer ' + abp.auth.getToken());
    }

    readFiles(response) {

        try {

            let filesRenamed = JSON.parse(response).result;

            filesRenamed.forEach(x => {
                this.uploadedFilesRenamed.push(x);
            });
        }
        catch (e) { }
    }

    deleteDocument(index: number): void {
        this.deletedAnyDocuments = true;
        this.documentation.documents.splice(index, 1);
        this.closeDisapproveDoc();
    }

    deletePendingDocument(index: number): void {
        this.uploadedFiles.splice(index, 1);
        this.uploadedFilesRenamed.splice(index, 1);
    }

    downloadFile(document: DocumentDto): void {

        this.loading = true;

        this._userService
            .getFile(document.documentId, document.fileExtension, document.id)
            .finally(() => { this.loading = false })
            .subscribe(result => {
                this._fileDownloadService.downloadTempFile(result);
            });
    }

    approve() {

        let input = new EntityDtoOfInt64();
        input.id = this.documentation.id

        this.savingDoc = true;
        this._memberAnnuityService.approveDocumentation(input)
            .finally(() => { this.savingDoc = false; })
            .subscribe(() => {
                this.documentation.note = undefined;
                this.documentation.status = DocumentationStatusMember.Approved;
                this.getAnnuitiesGenerated();
                this.notify.info(this.l('SavedSuccessfully'));
                this.modalSave.emit(null);
            }
            );
    }

    docsChanged(): boolean {
        return this.deletedAnyDocuments || this.uploadedFiles.length > 0;
    }

    openDisapproveDoc(): void {
        this.showMotiveDisapproveDoc = true;
        setTimeout(() => {
            $("[name='inputMotiveDisapprove']").focus();
        }, 0);
    }

    closeDisapproveDoc(): void {
        this.showMotiveDisapproveDoc = false;
        this.inputMotiveDisapproveDoc = '';
        this.savingDoc = false;
    }

    disapprove() {

        let input = new DisaproveDocDto();
        input.id = this.documentation.id;
        input.note = this.inputMotiveDisapproveDoc;

        this.savingDoc = true;
        this._memberAnnuityService.disapproveDocumentation(input)
            .finally(() => { this.savingDoc = false; })
            .subscribe(() => {
                this.documentation.note = this.inputMotiveDisapproveDoc;
                this.documentation.status = DocumentationStatusMember.Disapproved;
                this.closeDisapproveDoc();
                this.getAnnuitiesGenerated();
                this.notify.info(this.l('SavedSuccessfully'));
                this.modalSave.emit(null);
            }
            );
    }

    // Load Table
    getReceivables(event?: LazyLoadEvent) {

        if (!this.dataTablePaymentCharges || !this.user.id) {
            return null;
        }

        this.primengDatatableHelperPaymentCharges.showLoadingIndicator();

        this._paymentChargesService.getReceivables(
            this.user.id,
            undefined,
            undefined,
            undefined,
            ReceivableType.Receivable
        )
            .finally(() => {
                this.primengDatatableHelperPaymentCharges.hideLoadingIndicator();
            })
            .subscribe(result => {
                this.primengDatatableHelperPaymentCharges.totalRecordsCount = result.items.length;
                this.primengDatatableHelperPaymentCharges.records = result.items;
            });
    }

     getNewTicket(sendByEmail: boolean, record: any) {
       if (!sendByEmail){
        this.getTicket(sendByEmail, record).then((result) => {
                      this.ticketInfoModalComponent.show(
                        record.id,
                        this.user.name,
                        record.description,
                        record.dueDate,
                        record.netAmount,
                        result.link,
                        result.html,
                        result.barcode,
                        result.message
                    );
        });
      }
    }

    changeName() {

        this.user.confirmedName = true;
        this.user.name = this.user.nameValidSerpro;
    }

    keepName() {

        this.user.name = this.originalName;
        this.user.confirmedName = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/create-or-edit-user-modal.component.ts